<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0" v-bind:no-close-on-backdrop=true :hide-header=true v-model="is_show_modal" :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">{{__t('POS_EDIT')}}:{{this.pos.human_name}}</span>
                </h2>

                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">

                <b-overlay :show="is_load" rounded="sm">

                    <template v-slot:overlay>
                        <div class="text-center">
                            <b-icon icon="stopwatch" font-scale="2" animation="cylon"></b-icon>
                            <div class="mt-3">
                                <div class="">{{cur_status}}</div>
                            </div>
                        </div>
                    </template>

                    <div class="panel-content">
                        <div class="d-flex flex-column align-items-center justify-content-center p-4">
                            <h5 class="mb-0 fw-700 text-center mt-3">
                                {{this.pos.human_name}}
                            </h5>
                        </div>

                        <div class="panel-tag">
                            {{__t(this.pos.type + "_info".toUpperCase())}}
                        </div>

                        <div>
                            <b-tabs content-class="mt-3" v-if="!is_load">
                                <b-tab v-for="(tab,index) in tabs" @click="set_active(index)" :key="index" :active="tab.is_active">
                                    <template slot="title">
                                        {{ tab.title }}
                                    </template>
                                    <component v-bind:is="tab.index"></component>
                                </b-tab>
                            </b-tabs>
                        </div>

                    </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" @click="remove" class="btn btn-outline-danger waves-effect waves-themed mr-5 pl-5 pr-5" v-if="can_remove">
                    {{ __t('DETACH') }}
                </button>

                <button type="button" @click="close" class="btn btn-secondary waves-effect waves-themed">
                    {{ __t('CLOSE') }}
                </button>

                <button type="button" v-on:click="save" class="btn btn-primary waves-effect waves-themed">
                    {{ __t('SAVE') }}
                </button>
            </div>
        </template>

    </b-modal>
</template>

<script>

import {createHelpers} from "vuex-map-fields";
import pos_basic_settings from "./tabs/pos_basic_settings";
import pos_general_settings from "./tabs/pos_general_settings";
import pos_scheduler from "./tabs/pos_scheduler.vue";

const {mapFields} = createHelpers({
    getterType: 'pos/getPosStateField',
    mutationType: 'pos/updatePosStateField',
});


export default {
    name: "pos_settings_modal",
    props : {
        modal_position : {
            type : String,
            default : "right"
        },
    },

    components : {
        pos_basic_settings,
        pos_general_settings,
        pos_scheduler
    },

    created() {
        EventBus.$on("pos_edit", this.open);
        EventBus.$on("pos_edit_close",this.close);
    },

    data() {
        return  {
            cur_status : "",
            is_save : false,
            is_show_modal : false,
            is_load : false,
            active_tab_index: 0,
            /*tabs:[
                {
                    'title' : this.__t('GENERAL_POS'),
                    'is_active' : true,
                    'index' : 'pos_general_settings',
                },
                {
                    'title' : this.__t('BASIC_POS'),
                    'is_active' : false,
                    'index' : 'pos_basic_settings',
                },

                {
                    'title' : this.__t('SCHEDULER'),
                    'is_active' : false,
                    'index' : 'pos_scheduler',
                }
            ]*/
        }
    },

    methods : {

        open() {
            this.is_show_modal = true;
        },

        remove() {
            this.is_load = true;
            this.cur_status = "CLEANING...Please wait";
            pos_api.delete('/pos/' + parseInt(this.pos.id) + "/settings").then(({data}) => {
                if (data.status === "operation_success") {
                    this.close_and_reload();
                }
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    delay_time : 9000,
                    position : "b-toaster-top-left",
                    title: this.__t("ERR_DEL_POS")
                })
            });
        },

        close() {
            this.is_show_modal = false;
        },

        close_and_reload() {
            this.is_load = false;
            EventBus.$emit("reload_pos_base");
            this.close();
            this.cur_status = '';
        },

        save() {
            this.is_load = true;
            this
                //Check If valid options
                .validate_settings()
                .then(({data}) => {
                    this.cur_status = "VALIDATE_STATE :" + data.message;
                    return "OK"
                })
                .then(({data}) => {
                    return this.save_params();
                })
                .then(({data}) => {
                    this.is_load = false;
                    if (data.status === "operation_success") {
                        this.close_and_reload();
                    }
                })
                .catch(({response}) => {
                    this.is_load = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        delay_time : 9000,
                        position : "b-toaster-top-left",
                        title: this.__t("ERR_SAVE_POS")
                    })
                });
        },

        async save_params() {
            this.cur_status = this.__t('SAVE_POS');
            return pos_api.put('/pos/' + parseInt(this.pos.id) + "/settings", {
                "pos_params"   : this.pos_item.pos_params,
                "basic_params" : this.pos_item.basic_params
            });
        },

        validate_settings() {
            this.cur_status = this.__t('VALIDATE_POS');
            return pos_api.post('/pos/'  + parseInt(this.pos.id) + "/settings/validate/", {
                "pos_params" : this.pos_item.pos_params,
            });
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },


       /* set_active (obj) {
            for (let tab in this.tabs) {
                if(this.tabs.hasOwnProperty(tab)) {
                    this.tabs[tab].is_active = false;
                }
            }

            this.tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.tabs[obj].index, user_id: this.user_id});
        },*/


        set_active(index) {
            this.active_tab_index = index;

            EventBus.$emit('update:tabu', {
                type: this.tabs[index].index,
                user_id: this.user_id
            });
        },
    },

    computed : {

        tabs() {
            let res = [
                {
                    title: this.__t('GENERAL_POS'),
                    index: 'pos_general_settings',
                },
                {
                    title: this.__t('BASIC_POS'),
                    index: 'pos_basic_settings',
                },
            ];

            if (this.can_show_scheduler) {
                res.push({
                    title: this.__t('SCHEDULER'),
                    index: 'pos_scheduler',
                });
            }

            return res.map((tab, idx) => {
                tab.is_active = idx === this.active_tab_index;
                return tab;
            });
        },

        can_show_scheduler() {
            console.log(this.pos_item);

            if (!this.pos_item) {
                return false;
            }

            if (this.pos_item.hasOwnProperty('basic_params')) {
                if (this.pos_item.basic_params.hasOwnProperty('id')) {
                    return parseInt(this.pos_item.basic_params.id) > 0;
                }
            }

            return false;
        },


        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }
            return "modal-dialog-right modal-lg";
        },

        pos() {
            return this.pos_item.provider;
        },

        can_remove() {
            return this.pos_item.is_init;
        },

        ...mapFields([
            'pos_item'
        ])
    },


}
</script>

<style scoped>

</style>
